import { isNil } from "lodash/fp"
import { rsApiRequestForAd } from "../AdAdmin/functions"
import { format } from "date-fns/fp"

export const adUpload = async (file: File): Promise<boolean> => {
  const data = new TextDecoder().decode(await file.arrayBuffer())
  const result = await rsApiRequestForAd(`/v1/admin/ad/upload/contracts`, 'POST', {}, { file: data })
  if (isNil(result) || result.status !== 200) {
    return false
  }
  return result.data.success
}

export const adDownload = async (
): Promise<string | undefined> => {
  const date = format('yyyy-MM')(new Date())
  const result = await rsApiRequestForAd(`/v1/admin/ad/download/contracts`, 'GET', {}, {}, { date })
  if (isNil(result) || result.status !== 200 || isNil(result.data)) {
    return undefined
  }
  return result.data
}

export const adConfirmBankNumberUpload = async (file: File): Promise<boolean> => {
  const data = new TextDecoder().decode(await file.arrayBuffer())
  const result = await rsApiRequestForAd(`/v1/admin/ad/upload/confirm-banknumber`, 'POST', {}, { file: data })
  if (isNil(result) || result.status !== 200) {
    return false
  }
  return result.data.success
}
